import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import { Menu, Layout, Avatar, Popover, Row, theme, Button, Divider, Badge, Typography, Space } from 'antd';
import { LogoutOutlined, KeyOutlined } from '@ant-design/icons';
import { SessionContext } from '../../../shared/context/SessionContext';

import notification from '../../../assets/icons/notification/01.svg';

import './styles.css';

const { Header } = Layout;
const { Title, Text } = Typography;

export default function LayoutHeader(props) {
    const session = useContext(SessionContext);
    const { token: { colorBgContainer } } = theme.useToken();

    useEffect(() => {

    }, []);

    const content = () => {
        return (
            <div style={{ width: '300px' }}>
                <div className='padding-10'>
                    <Space align="center">
                        <Avatar size={64} style={{ color: '#fff', backgroundColor: '#ff7875', fontWeight: 500 }}>
                            {session.user.email.substring(0, session.user.email.lenght === 1 ? 1 : 2).toUpperCase()}
                        </Avatar>
                        <div>
                            <Title level={5} className='mb-0 mt-0'>{session.user.displayName ?? 'Bienvenido'}</Title>
                            <Text>{session.user.email}</Text>
                        </div>
                    </Space>
                </div>
                <Divider className='mt-5 mb-10' />

                <Link to={'/change-password'}>
                    <Button block
                        icon={<KeyOutlined />}
                        type="text"
                        onClick={null}
                        className='text-left'
                    >
                        Cambiar Contraseña
                    </Button>
                </Link>
                <Button block
                    icon={<LogoutOutlined />}
                    type="text"
                    onClick={props.onSignOut}
                    className='text-left'
                >
                    Cerrar Sesión
                </Button>

            </div>
        );
    }

    return (
        <Header style={{ padding: 0, background: colorBgContainer }}>
            <Menu
                mode="horizontal"
                className='direction-rtl'
                items={[
                    {
                        key: 'key-user',
                        label: (
                            <Popover placement="bottomRight" content={content} trigger="click">
                                <div className="user-content">
                                    <Avatar className="user-avatar">
                                        {session.user.email.substring(0, session.user.email.lenght === 1 ? 1 : 2).toUpperCase()}
                                    </Avatar>
                                </div>
                            </Popover>
                        )
                    },
                    {
                        key: 'key-notification',
                        onClick: props.onShowNotification,
                        label: (
                            <div className="user-content">
                                <img height={22} src={notification} />
                            </div>
                        )
                    }
                ]}
            />
        </Header>
    );
}